<template>
  <div id="custom-upload">
    <!-- Company certificate document -->
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="company-cert"
          class="strong-text"
        >
          {{ $t('kyc.comp_cert_doc') }}

        </div>
        <div class="pale-text center">
          ({{ $t('kyc.cert_not_over_six_months') }})
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.orgCompanyCert"
            name="company cert"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'orgCompanyCert')"
          >
            <section
              class="section"
              data-test="kyc-upload-org-doc--company-cert"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('company cert') }}</span>
          <b-tag
            v-if="form.orgCompanyCert"
            type="is-primary"
          >
            {{ form.orgCompanyCert.name }}
          </b-tag>
          <div
            v-if="orgCompanyCertOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- List of shareholders document -->
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="shareholders"
          class="strong-text"
        >
          {{ $t('kyc.list_shareholders_doc') }}
        </div>
        <div class="pale-text center">
          ({{ $t('kyc.cert_not_over_six_months') }})
        </div>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.orgShareholders"
            name="shareholders"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'orgShareholders')"
          >
            <section
              class="section"
              data-test="kyc-upload-org-doc--shareholders"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-list-shareholder.png"
                  class="dropzone-img--shareholders"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('shareholders') }}</span>
          <b-tag
            v-if="form.orgShareholders"
            type="is-primary"
          >
            {{ form.orgShareholders.name }}
          </b-tag>
          <div
            v-if="orgShareholdersOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- Seal certificate document -->
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="seal-cert"
          class="strong-text"
        >
          {{ $t('kyc.seal_cert_doc') }}
        </div>
        <div class="pale-text center">
          ({{ $t('kyc.cert_not_over_six_months') }} ({{ $t('kyc.if_any') }}))
        </div>
        <div class="example-img">
          <b-upload
            v-model="form.orgSealCert"
            name="seal cert"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'orgSealCert')"
          >
            <section
              class="section"
              data-test="kyc-upload-org-doc--seal-cert"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-list-shareholder.png"
                  class="dropzone-img--shareholders"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('seal cert') }}</span>
          <b-tag
            v-if="form.orgSealCert"
            type="is-primary"
          >
            {{ form.orgSealCert.name }}
          </b-tag>
          <div
            v-if="orgSealCertOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- Copy of house registration  of authorized director -->
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="house-regis-auth-director"
          class="strong-text"
        >
          {{ $t('kyc.copy_house_registration') }} ({{ $t('kyc.if_any') }})
        </div>
        <div class="example-img">
          <b-upload
            v-model="form.orgHouseRegisAuthDirector"
            name="house regis auth director"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'orgHouseRegisAuthDirector')"
          >
            <section
              class="section"
              data-test="kyc-upload-org-doc--house-regis-auth-director"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('house regis auth director') }}</span>
          <b-tag
            v-if="form.orgHouseRegisAuthDirector"
            type="is-primary"
          >
            {{ form.orgHouseRegisAuthDirector.name }}
          </b-tag>
          <div
            v-if="orgHouseRegisAuthDirectorOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- Power of attorney (optional) and message to use the service -->
    <div class="columns mg-t-20px">
      <div class="column document-box">
        <div
          id="power-attorney"
          class="strong-text"
        >
          {{ $t('kyc.power_attorney') }} ({{ $t('kyc.if_any') }})
        </div>
        <div class="example-img">
          <b-upload
            v-model="form.orgPowerAttorney"
            name="power attorney"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'orgPowerAttorney')"
          >
            <section
              class="section"
              data-test="kyc-upload-org-doc--power-attorney"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-power-of-attorney.png"
                  class="dropzone-img--attorney"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('power attorney') }}</span>
          <b-tag
            v-if="form.orgPowerAttorney"
            type="is-primary"
          >
            {{ form.orgPowerAttorney.name }}
          </b-tag>
          <div
            v-if="orgPowerAttorneyOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KYC_DOC_FILE_SIZE_LIMIT_IN_MB } from '@/constants'

export default {
  name: 'UploadOrgDocument',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      orgCompanyCertOverSize: false,
      orgShareholdersOverSize: false,
      orgSealCertOverSize: false,
      orgHouseRegisAuthDirectorOverSize: false,
      orgPowerAttorneyOverSize: false,
      limitFileSizeInMb: KYC_DOC_FILE_SIZE_LIMIT_IN_MB
    }
  },
  methods: {
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    }
  }
}
</script>

<style lang="scss">
#custom-upload {
  .upload .upload-draggable {
    width: 470px;
  }
  .tag {
    margin-top: 10px;
    span {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

@media only screen and (max-width: 768px) {
  #custom-upload {
    .upload .upload-draggable {
      width: 100%;
    }
    .tag {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.document-box {
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
}
.strong-text {
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
  margin-top: 30px;
  text-align: center;
}
.pale-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.67;
  letter-spacing: 0.37px;
  color: #939393;
  margin-top: 5px;
  &.center {
    text-align: center;
  }
}
.example-img {
  text-align: center;
  margin-top: 20px;
}
.dropzone-img {
  &--certificate {
    max-width: 173px;
    width: 100%;
  }
  &--shareholders {
    max-width: 420px;
    width: 100%;
  }
  &--attorney {
    max-width: 236px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .document-box {
    max-width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Organization/UploadOrgDocument.vue